import React from 'react';
import { HelpCircleIcon, HourglassIcon, LayersIcon, MapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  question: HelpCircleIcon,
  map: MapIcon,
  hourglass: HourglassIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-brand-choco" data-id="element-139" data-mp="2vppkp1bfdu9l">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-140" data-mp="39h4gy9ucfryl">
        <p className="inline-block rounded bg-brand-pink px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-141" data-mp="35garhc19653l">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-base font-extrabold leading-tight sm:text-xl" data-id="element-142" data-mp="3jdpigl75mkxo">
          Querés aprender pastelería para preparar productos deliciosos y
          comenzar a vender, pero{' '}
          <span className="bg-brand-blush px-1" data-id="element-143" data-mp="1k49bzq46wy9m">no sabés por dónde empezar.</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-choco/80" data-id="element-144" data-mp="je6c4p9sa246">
          Si estás comenzando desde cero o querés transformar tu pasión por la
          pastelería en un emprendimiento, probablemente conozcas alguna de estas
          situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-145" data-mp="x4s1mwtqtab1">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-brand-pink bg-brand-rose p-2.5 text-left" data-id="element-146" data-mp="172pnxes1kx10" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-pink" data-id="element-147" data-mp="1g2ugwjwhnsvn">
                  <Icon size={15} className="text-white" data-id="element-148" data-mp="3duyq3yjuvsti" />
                </span>
                <div data-id="element-149" data-mp="3hvir5d7jvgkx">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-brand-pinkdark" data-id="element-150" data-mp="3hwtrf31se67a">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-brand-choco/80" data-id="element-151" data-mp="k2qqrx942n4y">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}